import { render } from "./Auth.vue?vue&type=template&id=77d56bc8&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=77d56bc8&lang=scss&scoped=true"

import exportComponent from "/Users/ramazansapar/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d56bc8"]])

export default __exports__